import { getEnvironment } from "config/api";
import { useGetPaymentProviderQuery } from "store/queries/finix";

export function useFinixPaymentProvider(orderInfo: any) {
  const useFinix = orderInfo?.account?.features?.useFinix;

  const {
    data: providerData,
    isLoading,
    isError,
  } = useGetPaymentProviderQuery(orderInfo?.id, {
    skip: !useFinix || !orderInfo?.id,
  });

  const finixEnvironment: "sandbox" | "live" =
    getEnvironment() === "production" ? "live" : "sandbox";

  return {
    isFinix: !!useFinix,
    isLoading: useFinix ? isLoading : false,
    isError: useFinix ? isError : false,
    finixApplicationId: providerData?.finixApplicationId,
    finixMerchantId: providerData?.finixMerchantId,
    finixEnvironment,
  };
}
